export default {
  formServiceApi: ENV.formServiceApi,
  cheryApi: ENV.cheryApi,
  logicStarsApi: ENV.logicStarsApi,
  logicStarsKey: ENV.logicStarsKey,
  widgetStyle: {
    backgroundColor: '#f5f5f5',
  },
  initialValues: {
    confirm_personal_data_processing_policy: true,
  },
};
